function parse2query(data: any) {
  let str = ''
  const keys = Object.keys(data)
  if (keys.length) {
    Object.keys(data).forEach(key => {
      str += `${key}=${encodeURIComponent(data[key])}&`
    })
    str = str.substring(0, str.length - 1)
  }

  return str
}

export default parse2query
